import React, { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import { useScreenSize } from '../../../../../utils/media-query';
import { PopupGrid } from '../../../../script/components/popup/popup';
import { ScrollGrid } from '../../../../script/components/data-grid/data-grid-body/grid-bodys';
import { BoolCol, CommCol } from '../../../../script/components/data-grid/data-grid-column/grid-column';
import { CheckBox } from 'devextreme-react';
import { fwUtil } from '../../../../script/util';

const keyExpr = ['menu_code', 'menu_gubu'];  // 데이터 키

export function UserAuthChanUpdateMES(props) {
    const {
        gridRef,
        targetApi, updateApi,
        visible, hiding
    } = props;

    const { isXSmall, isSmall } = useScreenSize();
    const [loading, setLoading] = useState(false);
    // 데이터
    const [data, setData] = useState([]);
    const dataUpdate = useCallback((e) => setData(e), [setData]);
    // 그리드
    const authGridRef = useRef(null);
    const [dispose, setDispose] = useState(false);
    const disposeChange = useCallback((e) => setDispose(e), []);

    // 열릴 때
    const onShowing = useCallback(() => {
        setLoading(true);
    }, [setLoading]);

    // 선택 데이터 조회
    const onShown = useCallback(async () => {
        const selectedRowKey = fwUtil.grid.get.sKey(gridRef);
        if (selectedRowKey && visible) {
            const sendData = { userIdno: selectedRowKey };
            const res = await fwUtil.apis.search(targetApi, sendData);
            dataUpdate(res);   
        }
        setLoading(false);
        if (!selectedRowKey || !visible) {
            hiding();
        }
    }, [gridRef, visible, targetApi, dataUpdate, setLoading, hiding]);

    // 제출
    const onSubmit = useCallback(async () => {
        const postData = data || [];
        if (postData) {
            setLoading(true);
            await fwUtil.apis.submit(updateApi, postData);
            setLoading(false);
            hiding();
        } else {
            fwUtil.aler.toast.a1Erro();
        }
    }, [data, updateApi, hiding]);

    // 열 전체 선택
    const checkAllColumns = useCallback((dataField, value) => {
        const grid = authGridRef.current;
        if (grid) {
            const oldsData = data;
            const updatedData = oldsData.map(item => ({
                ...item,
                [dataField]: value
            }));

            dataUpdate(updatedData);
        }
    }, [data, dataUpdate, authGridRef]);

    const renderBoolCellHeader = useCallback((e) => (
        <div className='fw-all-checker fw-column-flex-box'>
            <span className='fw-all-checker-text'>{e.column?.caption}</span>
            <div className='fw-all-checker-checkbox-wrapper'>
                <CheckBox
                    className='fw-all-checker-checkbox selector'
                    hint={`${e.column?.caption} 권한 전체 선택`}
                    value={true}
                    onValueChange={() => checkAllColumns(e.column.dataField, 1)}
                />
                <CheckBox
                    className='fw-all-checker-checkbox deselector'
                    hint={`${e.column?.caption} 권한 전체 해제`}
                    value={false}
                    onValueChange={() => checkAllColumns(e.column.dataField, 0)}
                />                      
            </div>
        </div>
    ), [checkAllColumns]);

    useEffect(() => {
        if (!visible) {
            setData([]);
            disposeChange(true);
        } else {
            disposeChange(false);
        }
    }, [visible, setData, disposeChange]);

    const gridBody = useMemo(() => (
        <ScrollGrid
            gridDataSource={data}
            gridRef={authGridRef}
            mainKey={keyExpr}
            width={isXSmall || isSmall ? '100%' : 905}
            height={isXSmall || isSmall ? '90%' : 600}
            edit
            dispose={dispose}
        >
            {CommCol({ dataField: "menu_name", caption: "메뉴명", width: 120, allowEditing: false, allowFiltering: true })}
            {CommCol({ dataField: "menu_gubu", caption: "메뉴구분", width: 120, allowEditing: false, allowFiltering: true })}
            {BoolCol({ dataField: "auth_acce", caption: "접근", width: 90, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
            {BoolCol({ dataField: "auth_sele", caption: "조회", width: 90, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
            {BoolCol({ dataField: "auth_inse", caption: "입력", width: 90, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
            {BoolCol({ dataField: "auth_upda", caption: "수정", width: 90, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
            {BoolCol({ dataField: "auth_dele", caption: "삭제", width: 90, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
            {BoolCol({ dataField: "auth_uplo", caption: "업로드", width: 100, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
            {BoolCol({ dataField: "auth_dnlo", caption: "다운로드", width: 110, headerCellRender: renderBoolCellHeader, allowFiltering: false, allowSorting: false })}
        </ScrollGrid>
    ), [data, renderBoolCellHeader, isXSmall, isSmall, dispose]);

    return ( 
        <PopupGrid
            title={'사용자 권한부여'}   
            type={'수정'}
            loading={loading}
            visible={visible}  
            showing={onShowing}
            shown={onShown}  
            hiding={hiding}
            onSubmit={onSubmit}
            width={isXSmall || isSmall ? '100%' : 930}
            height={isXSmall || isSmall ? '100%' : 'auto'}
            maxHeight={isXSmall || isSmall ? '100%' : '95%'}
        >   
            {gridBody}
        </PopupGrid>
    );
}